import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";

export const GET_ACTIVE_USER = gql(`
  query getActiveUser {
    me {
      __typename
      id
      fullName
      email
    }
  }
`);

export function useGetActiveUser() {
  return useQuery(GET_ACTIVE_USER);
}
